import "./PreviewProjectComp.css"
import {GlobalLangCtx} from '../../App'
import { useState, useEffect, useContext } from "react"

// projectsJS[it].js

function getFileProjectConf(projectProp, globalLan){

    // prende e ritorna il primo file di configurazione del progetto
    // che non risulta null

    const {projectsPHP} = require(`../json_archivies/projects${projectProp.proName}[${globalLan}].js`);
    const {projectsReact} = require(`../json_archivies/projects${projectProp.proName}[${globalLan}].js`);
    const {projectsVue} = require(`../json_archivies/projects${projectProp.proName}[${globalLan}].js`);
    const {projectsNode} = require(`../json_archivies/projects${projectProp.proName}[${globalLan}].js`);
    const {projectsLaravel} = require(`../json_archivies/projects${projectProp.proName}[${globalLan}].js`);
    const {projectsJS} = require(`../json_archivies/projects${projectProp.proName}[${globalLan}].js`);

    let cProject = null;
    if(projectsPHP){
        cProject = projectsPHP;
    }

    if(projectsReact){
        cProject = projectsReact;
    }

    if(projectsJS){
        cProject = projectsJS;
    }

    if(projectsVue){
        cProject = projectsVue;
    }

    if(projectsNode){
        cProject = projectsNode;
    }

    if(projectsLaravel){
        cProject = projectsLaravel;
    }
    return cProject;
}



function extractProjectFileProps(cProject, selectedProject){

    let {title}         = cProject[0].projectProps[selectedProject];
    let {long_desc}     = cProject[0].projectProps[selectedProject];
    let {topics}        = cProject[0].projectProps[selectedProject];
    let {location_url}  = cProject[0].projectProps[selectedProject];
    let {img}           = cProject[0].projectProps[selectedProject];
    let {source_code}   = cProject[0].projectProps[selectedProject];

    return {title, long_desc, topics, location_url, img, source_code};
}


const PreviewProjsComp = ({setParentState, projectProp}) =>{

// let cPro = -1;

    
    let projID = projectProp.proId;
    const [globalLan] = useContext(GlobalLangCtx);
    const [curProject, setCurProject] = useState(projID);

    useEffect(() =>{
        document.querySelector(".projLink > a:nth-child(1)").focus();
        document.querySelector(".projLink > a:nth-child(1)").blur();
        window.location.href = '#mainContainter';
    },[curProject])

    const {PreviewProject} = require(`../language_app/json_files/lang[${globalLan}].json`)
    const cProject = getFileProjectConf(projectProp, globalLan);

    let {title, long_desc, topics, location_url, img, source_code} = extractProjectFileProps(cProject, curProject);
    
        const handleClose = () =>{
            setParentState( {proName: "", proId: -1} ) 
        }

        let cont = parseInt(curProject);
        const handleForward = () =>{
            cont++;
    
            if(cont < cProject[0].projectProps.length){
                setCurProject(cont)
            }
            else{
                setCurProject(0)
                cont = 0;
            }

        }

        const handleBackward = () =>{

            if(cont === 0) cont = cProject[0].projectProps.length;
            cont = cont - 1;
            setCurProject(cont);

        }
            return(
                <section id='mainContainter' className="pPreviewMainBlk">
                    <div id='mainPlcHld' className='prevProjsTitleBar'>

                        <h1 className="mainTitle">
                            {PreviewProject.title}
                        </h1>

                    </div>

                    <div className="mainTitleProjContainer">
                        <div id="titleBar">

                            <div className='ctrlBlk'>
                                <div onClick={()=> handleBackward() }className="ctrlsPreview">&lt;</div>
                                <div className="ctrlsPreview">\</div>
                                <div onClick={()=> handleForward() }className="ctrlsPreview">&gt;</div>
                            </div>

                            <div className="mainTitleProj">
                                { title } 
                            </div>

                            <div title={PreviewProject.msg_close} className="xBtn" onClick={ () => { handleClose() } } >
                                   X
                            </div>
                        </div>

                    </div>

                    <div className="blksContents">
                            <div className="blkImg">

                                <div className="img_container">
                                    <img className="img_res" src={img} alt="" />
                                </div>

                            </div>
                            <div className="desc_container">

                                <div className="descBlks descLab" >
                                    {PreviewProject.desc_title}
                                </div>

                                    <div className="descBlks" dangerouslySetInnerHTML={{__html: long_desc} }></div>
                                
                                <div className="descBlks descTopics">
                                   <div className="topicsLab"> Topics: </div> { topics }
                                </div>

                            </div>
                    </div>

                    <div className="projLink">
                        <a target='_blank'  rel="noreferrer" href={location_url}> { (source_code) ? "source" : "project" }  </a>
                    </div>
    
                </section>
            )
    }
    
export default PreviewProjsComp;